<template>
  <div class="location-container section-container">
    <div class="location-message section-message">
      <h2>Location</h2>
      <p>Address:<br />720 NE Burnside Rd,<br />Gresham, OR 97030</p>
      <p>Phone Number:<br />(503) 665-3791</p>
    </div>
    <div class="location-map-wrapper section-image dp-9">
      <gmap-map :center="center" :zoom="17">
        <gmap-marker
          :position="marker.position"
          :clickable="true"
          @click="center = marker.position"
        ></gmap-marker>
      </gmap-map>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import * as GmapVue from "gmap-vue";
import { gmapApi } from "gmap-vue";

Vue.use(GmapVue, {
  load: {
    key: "AIzaSyAmqDfLZxUI2uQPjJOayzAYq1KuploSyOY"
  },
  installComponents: true
});

Vue.component("google-map", GmapVue.Map);
Vue.component("google-marker", GmapVue.Marker);

export default {
  name: "Location",
  data: function() {
    return {
      center: {
        lat: 45.506851,
        lng: -122.42349
      },
      marker: {
        position: {
          lat: 45.506851,
          lng: -122.42349
        }
      }
    };
  },
  mounted() {},
  computed: {
    google: gmapApi
  }
};
</script>

<style lang="scss">
.vue-map-container {
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
}
</style>
